import isBoolean from 'lodash/isBoolean';
import { setCookie } from '../../../../utils/cookie';
import { ccpaOptOutCookie } from '../../../../constants/cookies';
import { isUserOptedOutUnderCcpa } from '../../../../utils/optOut/checkUserOptOutStatus';

const YES = 'Y';
const NO = 'N';

// CCPA Status Format: [Version number][Explicit notice][Opt out][LSPA]
// Note: formatted with dot delimiter in cookie for clear separation of values

// Version number - Currently hardcoded as `1`. May be updated in the future.
const VERSION_NUMBER = '1';

// Explicit notice - Hardcoded so long as we have the home screen link and settings toggle live
const EXPLICIT_NOTICE = YES;

// Opt out - Based on user preference for allowing us to share their data (determined dynamically)

// LSPA - Hardcoded as we are a signatory of the IAB Limited Service Provider Agreement
const LSPA = YES;

export const generateCcpaStatusValue = (override) => {
  const hasUserOptedOut = isBoolean(override)
    ? override
    : isUserOptedOutUnderCcpa();
  return `${VERSION_NUMBER}${EXPLICIT_NOTICE}${
    hasUserOptedOut ? YES : NO
  }${LSPA}`;
};

export const setCcpaCookie = (hasUserOptedOut) => {
  setCookie(ccpaOptOutCookie.name, null, hasUserOptedOut);
};
